import { apiGet } from '@/features/shared/utils/dataFetching'
import { type QueryFunctionContext } from '@tanstack/react-query'
import {
  type BannersKey,
  type MembershipEntryPointBannerKey,
} from '@/features/shop/services/Banners/queries'
import {
  type BannerResponse,
  type MembershipEntryPointBannerResponse,
} from '@/features/shop/services/Banners/types'

export const fetchBanners = (context: QueryFunctionContext<BannersKey>) => {
  const [, params] = context.queryKey
  return apiGet<BannerResponse>({
    config: { url: 'banners/v1', params },
    context,
    fetcherName: 'fetchBanners',
  })
}

export const fetchSubscriptionAuxiliaryBanners = async (
  context: QueryFunctionContext<MembershipEntryPointBannerKey>,
): Promise<MembershipEntryPointBannerResponse | null> => {
  const [, params] = context.queryKey

  const response = await apiGet<MembershipEntryPointBannerResponse | void>({
    config: {
      url: 'subscription-auxiliary/v1/ghp-banners',
      params,
      onErrorLog: { ...params },
    },
    context,
    fetcherName: 'fetchSubscriptionAuxiliaryBanners',
  })
  return response || null
}
